import { useEffect, useState } from 'react';
import { VscLoading } from 'react-icons/vsc';
import { useSelector } from 'react-redux';
import { Heading4 } from '../../../../../../Components/FormHeading';
import SearchBox from '../../../../../../Components/SearchBox';
import { debounce, ErrorMessageHandler } from '../../../../../../_helpers/_methods';
import { CourseItemContainer, CourseLoading, StyledCourseItem } from '../../EventStep5';

// eslint-disable-next-line no-undef
const KMS_API = process.env.REACT_APP_KMS_BACKEND_URL;
function CourseAddition({ selectedCourses, handleCourseClick }) {
  const [isCourseLoading, setIsCourseLoading] = useState();
  const [courses, setCourses] = useState([]);
  const local = useSelector((state) => state.local.local);

  const getCourse = (title) => {
    try {
      setIsCourseLoading(true);
      let url = `${KMS_API}/course/`;
      if (title) {
        url += `?title=${title}`;
      }

      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          setIsCourseLoading(false);
          setCourses(data.data.results);
        });
    } catch (error) {
      console.log(error, 'error');
      setIsCourseLoading(false);
      ErrorMessageHandler(error);
    }
  };
  useEffect(() => {
    getCourse();
  }, []);

  const handleCourseFetch = (e) => {
    let typedTitle = e.target.value;
    getCourse(typedTitle);
  };
  return (
    <>
      <div className="d-flex justify-content-center mb-3">
        <SearchBox
          className={'large'}
          placeholder={local === 'ne' ? 'पाठ्यक्रम खोज्नुहोस' : 'Search courses'}
          onChange={debounce(handleCourseFetch, 200)}
        />
      </div>
      {isCourseLoading ? (
        <CourseLoading>
          <VscLoading className="spin" fontSize={60} color="#007bff" />
        </CourseLoading>
      ) : (
        <CourseItemContainer>
          <div className="d-flex justify-content-center row p-2">
            {courses.lenght < 1 ? (
              <div className="d-flex justify-content-center align-items-center">
                No course found
              </div>
            ) : (
              courses.map((course) => {
                let isSelected =
                  selectedCourses?.findIndex((linkedCourse) => linkedCourse.id === course.id) > -1;
                return (
                  <StyledCourseItem
                    key={course.id}
                    className={`col-5 mx-1 ${isSelected ? 'selected' : ''}`}
                    onClick={() => {
                      handleCourseClick(course);
                    }}>
                    <div>
                      <div className="thumbnail_container">
                        <img
                          src={
                            course.thumbnail_image
                              ? course.thumbnail_image
                              : '/assets/images/placeholder.jpg'
                          }
                          alt={course.title}
                        />
                      </div>
                    </div>
                    <div className="course-info">
                      <Heading4>{course.title}</Heading4>
                    </div>
                  </StyledCourseItem>
                );
              })
            )}
          </div>
        </CourseItemContainer>
      )}
    </>
  );
}

export default CourseAddition;
